import React from 'react'
import FaPlus from 'react-icons/lib/fa/plus';
import FaCalendar from 'react-icons/lib/fa/calendar';
import Modal from '../../../common/components/Modal';
import { Link } from 'react-router-dom'

import WorkspaceStore from '../../../common/flux/stores/WorkspaceStore'

class CreatedEventModal extends React.Component {
    constructor (props) {
        super(props)
        
        let data = false
        if (props.hasOwnProperty('createdEvent') && !!props.createdEvent) {
            data = props.createdEvent
        }

        this.state = {
            viewable: data,
            createdEvent: data
        }

        this.onChange = this.onChange.bind(this)
        this.reset = this.reset.bind(this)
    }

    onChange () {
        let lce = WorkspaceStore.getLastCreatedEvent()
        this.setState({
            viewable: lce !== null,
            createdEvent: lce
        })
    }

    componentWillMount () {
        WorkspaceStore.addCreatedEventListener(this.onChange)
    }

    componentWillUnmount () {
        WorkspaceStore.removeCreatedEventListener(this.onChange)
    }

    reset () {
        if (this.props.hideOverlay) this.props.hideOverlay()
        this.setState({
            viewable: false,
            createdEvent: null
        })
    }

    render () {
        if (!this.state.viewable) return null

        let cancelAction
        if (this.props.mode === 'route-create') {
            cancelAction = () => {
                if (this.props.hideOverlay) this.props.hideOverlay()
                this.props.reset()
            }
        } else {
            cancelAction = () => {
                if (this.props.hideOverlay) this.props.hideOverlay()
                this.reset()
            }
        }

        return <Modal cancelModal={cancelAction}>
            <Modal.Header>
                Event Created
            </Modal.Header>
            <Modal.Body>
                <h3>
                    <Link data-testid="created-event-modal-link" to={"/events/?eventID=" + this.state.createdEvent.data.eventID}>
                        <strong>{this.state.createdEvent.data.title}</strong>
                    </Link>
                    <br/>
                    <small>Event ID: {this.state.createdEvent.data.eventID}</small>
                </h3>
            </Modal.Body>
            <Modal.Footer>
                <Link role="button" className="btn btn-link" to="/events">
                    <FaCalendar/> Events Listing
                </Link>
                {this.props.mode != 'route-listing'?
                    <button className="btn btn-success" onClick={e => {
                        this.props.showCreateModal ? this.props.showCreateModal() : {}
                        this.props.reset(e)
                    }}>
                        <FaPlus/> Create a New Event
                    </button> :
                    <button className="btn btn-success" onClick={e => {
                        this.props.showCreateModal()
                        this.props.reset ? this.props.reset(e) : this.reset(e)
                    }}>
                        <FaPlus/> Create a New Event
                    </button>
                }
            </Modal.Footer>
        </Modal>
    }
}

export default CreatedEventModal